import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-chart-pie-icon',
  templateUrl: './shopping-chart-pie.component.html'
})
export class ShoppingChartPieComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
